import Draft from "draft-js";
import { getEntitySelections } from "./getEntitySelections";
import { moveToEndOfSelection } from "./moveToEndOfSelection";

type ReplaceEntityText = (
  editorState: Draft.EditorState,
  targetSelection: Draft.SelectionState,
  text: string,
  options: {
    type: string;
    mutability: Draft.DraftEntityMutability;
    data?: Object;
  },
) => {
  nextEditorState: Draft.EditorState;
  nextEntityKey: string;
};
/**
 * Replace selection with new text and apply an entity
 */
export const replaceEntityText: ReplaceEntityText = (
  editorState,
  targetSelection,
  text,
  { type, mutability, data },
) => {
  const content = editorState.getCurrentContent();
  const userSelection = editorState.getSelection();

  // Create our entity
  const contentWithEntity = content.createEntity(type, mutability, data);
  const entityKey = contentWithEntity.getLastCreatedEntityKey();

  // Replace target selection text and apply our entity
  const nextContent = Draft.Modifier.replaceText(
    contentWithEntity,
    targetSelection,
    text,
    undefined,
    entityKey,
  );

  const entitySelection = getEntitySelections(nextContent, entityKey).pop();

  // Update editor state and move selection to the end of the entity
  return {
    nextEditorState: Draft.EditorState.forceSelection(
      Draft.EditorState.push(editorState, nextContent, "apply-entity"),
      moveToEndOfSelection(entitySelection || userSelection),
    ),
    nextEntityKey: entityKey,
  };
};
